<template>
  <div id="section-to-print" ref="pdfContent">
    <div class="row page-break page-break-length">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <!-- <div class="printme"> -->
              <h5 style="font-weight: bold">
                PERUSAHAAN UMUM DAERAH AIR MINUM
              </h5>
              <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
              <h4 class="header-title">
                <strong
                  >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN BLA BLA</strong
                >
              </h4>
              <h5 class="header-periode" style="padding-bottom: 20px">
                <strong>UNTUK BULAN: AGUSTUS 2023</strong>
              </h5>

              <table class="table" v-if="gajis">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="3">NO</th>
                    <th class="wider-column" rowspan="3">
                      NAMA<br />
                      <br />NIP/NIK<br />JABATAN
                    </th>
                    <th rowspan="3" colspan="2">GOL.</th>
                    <th rowspan="2">GAJI POKOK</th>
                    <th colspan="7" rowspan="1">TUNJANGAN</th>
                    <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                    <th rowspan="2">JUMLAH BRUTO</th>
                    <th rowspan="2">TUNJANGAN PPH</th>
                    <th rowspan="2">JUMLAH (14+15)</th>
                    <th rowspan="1" colspan="5">POTONGAN</th>
                    <th rowspan="3">JUMLAH YANG DITERIMA</th>
                    <th rowspan="3" colspan="2">TANDA TANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th>
                      PERUSAHAAN
                      <div class="small-text">(5)x 25%</div>
                    </th>
                    <th>JABATAN</th>
                    <th>
                      KEMAHALAN
                      <div class="small-text">(5)x 5%</div>
                    </th>
                    <th>AIR</th>
                    <th>TRANSPORT</th>
                    <th>PANGAN</th>
                    <th>KESEHATAN</th>
                    <th>HARI</th>
                    <th>
                      JUMLAH
                      <div class="small-text">13X5%(6+10)</div>
                    </th>
                    <th>KESEHATAN</th>
                    <th>
                      BPJS TK 3 PROGRAM
                      <div class="small-text">(15)X2%</div>
                    </th>
                    <th>
                      BPJS TK 4 PROGRAM
                      <div class="small-text">(Bts maxX1% JP)+ 2% JHT</div>
                    </th>
                    <th>PENSIUN JIWASRAYA</th>
                    <th>PPH</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="border: none">(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                    <th>7</th>
                    <th>8</th>
                    <th>9</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>13</th>
                    <th>14</th>
                    <th>15</th>
                    <th>16</th>
                    <th>17</th>
                    <th>18</th>
                    <th>19</th>
                    <th>20</th>
                    <th>20</th>
                    <th>21</th>
                    <th>22</th>
                    <th></th>
                    <th>24</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gajis.gajis"
                    :key="item.id"
                    :class="'top-text table-row-vfor'"
                    :style="getPageBreakStyle(index)"
                  >
                    <td style="border: 1px solid #000">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000" class="wider-column">
                      {{ item.pegawai.nama }} <br />
                      <br />NIK.
                      {{ item.pegawai.nik }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ item.golongan.nama }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ item.pegawai.status_ptkp }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.gaji_pokok) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_perusahaan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_jabatan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kemahalan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_air) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_transport) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pangan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kesehatan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_tdk_hadir) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_bruto) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen + item.jml_bruto) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_kesehatan) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pensiun) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.total_diterima) }}
                    </td>
                    <td style="border: 1px solid #000" class="bottom-text">
                      {{ index + 1 }}
                    </td>
                    <td class="bottom-text">...............</td>
                  </tr>
                </tbody>
                <!-- <tfoot> -->
                <tr class="top-text table-row-vfor" v-if="gajis.totalGajis">
                  <td style="border: 1px solid #000"></td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    JUMLAH
                  </td>
                  <td style="border: 1px solid #000"></td>
                  <td style="border: 1px solid #000"></td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.gaji_pokok) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_perusahaan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_jabatan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_kemahalan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_air) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_transport) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_pangan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_kesehatan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.jml_tdk_hadir) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.pot_5_persen) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.jml_bruto) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.tun_pph) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(
                        gajis.totalGajis.pot_5_persen +
                          gajis.totalGajis.jml_bruto
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.pot_kesehatan) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(gajis.totalGajis.pot_bpjs_tk_tiga_program)
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(gajis.totalGajis.pot_bpjs_tk_empat_program)
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.pot_pensiun) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.pot_pph) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajis.totalGajis.total_diterima) }}
                  </td>
                  <td style="border: 1px solid #000" class="bottom-text"></td>
                  <td class="bottom-text"></td>
                </tr>
                <!-- </tfoot> -->
              </table>
            </div>
          </div>
          <div class="row" v-if="gajis">
            <div class="col-12">
              <p>
                <!-- {{ formatNumber(gajis.totalGajis.pot_pph) }} -->
                Terbilang : -----
                {{
                  formatNumberTerbilang(
                    gajis.totalGajis.pot_5_persen + gajis.totalGajis.jml_bruto
                  )
                }}
                Rupiah -----
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              Perumda Air Minum <br />
              Tirta Hita Buleleng <br />
              Menyetujui: <br />
              <br />
              <br />
              <div
                style="text-decoration: underline; padding-top: 35px"
                v-if="pejabatMengetahui"
              >
                {{ pejabatMengetahui.nama }}
              </div>

              Direktur Umum
            </div>
            <div class="col-6">
              <br />
              <div v-if="gajis">
                Singaraja, {{ convertTgl(gajis.gajis[0].created_at) }}
              </div>

              Dibuat Oleh:<br />
              <br />
              <br />
              <div
                style="text-decoration: underline; padding-top: 35px"
                v-if="pejabatMembuat"
              >
                {{ pejabatMembuat.nama }}
              </div>
              Ka. Sub Bag. Personalia
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12  -->
    </div>

    <!-- gaji pegawai tetap -->

    <!-- /row  -->
  </div>
  <div class="row no-print">
    <div class="col-6">
      <a
        href=""
        @click.prevent="print()"
        target="_blank"
        class="btn btn-default"
        ><i class="fa fa-print"></i>Print</a
      >
    </div>
    <div class="col-6">
      <a
        href=""
        @click.prevent="generatePDF()"
        target="_blank"
        class="btn btn-default"
        ><i class="fa fa-download"></i>DOWNLOAD PDF</a
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
//PAGE-BREAK
tfoot {
  display: table-footer-group;
}

//END OF PAGE-BREAK
/* Custom CSS to make table borders thicker */
.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  // table-layout: fixed;
}

.table th,
.table td {
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 0;
}
td {
  padding: 0;
}

th {
  padding: 0;
}

.table-row-vfor {
  border: 1px solid #000;
  // border-left: 1px solid #000;
}

.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.top-text {
  vertical-align: top;
}
.bottom-text {
  vertical-align: bottom;
}

// table {
//   width: 100%;
//   table-layout: fixed; /* Use fixed table layout */
// }

.small-text {
  font-size: 8px;
}
.header-title {
  text-align: center;
}
.header-periode {
  text-align: center;
}

// .wider-column {
//   width: 5%; /* Adjust this value to make the column wider or narrower */
// }

.add-page-break {
  page-break-before: always;
}

@media print {
  //ini errorr
  // .page-break {
  //   display: block;
  //   page-break-before: auto;
  // }
  /* Define a class for the page break */
  // .page-break {
  //   page-break-before: always; /* Use 'after' to add a break after the element */
  //   /* You can also specify other properties like 'margin', 'padding', etc. */
  // }

  /* Optional: Set the length after which a page break should occur */
  // .page-break-length {
  //   height: 10cm; /* Adjust this value as needed */
  // }

  //bARUU

  table {
    page-break-inside: auto;
  }

  tr {
    page-break-inside: auto;
  }

  // tbody tr:nth-child(10n + 1) {
  //   page-break-before: always;
  // }

  main {
    visibility: hidden;
    margin: 0; /* Remove default margins */
    width: 100%; /* Use the full width of the page */
  }
  .no-print {
    visibility: hidden;
  }

  #section-to-print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
<script>
import html2pdf from "html2pdf.js";
import axios from "axios";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
// import Widget from "devextreme/ui/widget/ui.widget";

// async function fetchData() {
//   const config = {
//     headers: {
//       "content-type": "application/json",
//     },
//   };
//   var data = {
//     pegawai_status_id: 1,
//     tgl_gaji: "2023-07-01",
//   };
//   const response = await axios.post(
//     "http://127.0.0.1/api/get_gaji",
//     data,
//     config
//   );
//   console.log(response.data);
//   return response.data;
// }

export default {
  // Component logic goes here
  data() {
    return {
      gajis: null,
      gajiTetap: null,
      pejabatMengetahui: null,
      pejabatMembuat: null,
    };
  },
  async mounted() {
    //gajitetap
    //per cabang, per bagian

    this.gajis = await this.fetchDataGaji([2, 5], "2023-07-01");
    await this.fetchDataPejabatPembuatGaji();
    // this.gajis =
    console.log("hello", this.gajis);
    // this.storeDireksi = await this.fetchData(1);
  },
  methods: {
    getPageBreakStyle(index) {
      console.log("getPageBreakStyle", index);
      if (index === 10 || (index > 10 && (index - 9) % 11 === 0)) {
        console.log("apply page-break-before");
        return {
          "page-break-before": "always",
        };
      }
    },
    generatePDF() {
      const createpdf = this.$refs.pdfContent;
      console.log(createpdf);
      var opt = {
        margin: 10,
        filename: "gajipdfcreated.pdf",
        html2canvas: {
          scale: 1,
        },
        jsPDF: { unit: "mm", format: [330, 447], orientation: "landscape" },
      };
      html2pdf().set(opt).from(createpdf).save();
    },
    convertTgl(inputDate) {
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      console.log(formattedDate);
      return formattedDate;
    },
    async fetchDataGaji(pegawaiStatusId, tglGaji) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        pegawai_status_ids: pegawaiStatusId,
        tgl_gaji: tglGaji,
      };
      console.log(data);
      try {
        const response = await axios.post(
          "http://127.0.0.1/api/get_gaji",
          data,
          config
        );

        return response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const response = await axios.get("http://127.0.0.1/api/pejabat_gaji");
        this.gaji = response.data.gajis;
        this.pejabatMengetahui = response.data.dirum;
        this.pejabatMembuat = response.data.kasubagPersonalia;
        console.log("HASIL pejabatMengetahui", this.pejabatMengetahui);
        // console.log("HASIL SUMGAJIS", this.sumgajis);
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        console.log(angkaTerbilang(stringValue));
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    print() {
      // const bodyElement = document.getElementsByClassName("printme")[0];

      // bodyElement.classList.add("printing");
      // window.print();
      // bodyElement.classList.remove("printing");

      console.log("HELLO");
      window.print();
    },
  },
};
</script>
